<template>
  <div>
    <v-list-item
      :to="to"
      v-bind="customAttrs"
      class="v-list-item--doc nav-item"
      color="accent"
      ripple
      :class="{ 'mb-2': header }"
      :style="header ? 'padding-left: 26px;' : ''"
      v-on="$listeners"
    >
      <v-list-item-avatar
        v-if="avatar"
        :color="avatarColor"
      >
        <v-img
          style="max-width: 24px; height: 24px"
          :src="avatar"
          alt="avatar"
        />
      </v-list-item-avatar>

      <v-list-item-icon v-else-if="icon">
        <v-icon v-text="icon" />
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>
          <span
            :class="{ 'text-uppercase': header }"
            v-text="text"
          />
        </v-list-item-title>
      </v-list-item-content>

      <slot />
    </v-list-item>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    avatar: {
      type: String,
      default: undefined
    },
    avatarColor: {
      type: String,
      default: undefined
    },
    text: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      default: ''
    },
    icon: {
      type: [Boolean, String],
      default: false
    },
    to: {
      type: String,
      default: undefined
    },
    header: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    customAttrs() {
      const attrs = {
        ...this.$attrs
      }
      if (this.href) {
        attrs.target = this.target
        attrs.rel = 'noopener'
        attrs.href = this.href
      }
      return attrs
    }
  }
}
</script>
<style lang="scss" scoped>

::v-deep {
  .nav-item {
    background-color: var(--v-darkbg-base);
    margin-left: -0.5rem;
    margin-right: -0.5rem;
    .v-list-item__title {
      font-size: 1rem;
      line-height: 1.1rem;
    }

    &:not(.v-list-item--active):not(.v-list-item--disabled) {
      opacity: 0.7;
      color: white;
      .v-icon {
        color: white;
      }
      &:hover {
        opacity: 1;
      }
    }
    &.v-list-item--active {
      background-color: var(--v-accent-base);
      .v-list-item__content {
        color: white;
      }
      .v-icon {
        color: white;
      }
    }
  }

  .v-list-item__avatar {
    margin-left: -0.5rem;
  }
}

</style>
